import React from 'react';

const CheckboxField = ({ field, onInputChange }) => {
    const { label, cssClass, choices, value } = field;
    return (
        <div className={`form-field ${cssClass}`}>
            {choices?.map((choice, index) => (
                <div className="checkbox" key={`${field.id}-${index}`}>
                    <input
                        name={label.toLowerCase()}
                        type="checkbox"
                        id={index}
                        value={value ? value : ''}
                        checked={value === "Yes"}
                        onChange={onInputChange}
                    />
                    <label htmlFor={index}>{label}</label>
                </div>
            ))}
        </div>
    );
}

export default CheckboxField;